"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteOAuth = exports.deleteJWT = exports.setOAuth = exports.setJWT = exports.getOAuth = exports.getJWT = exports.OAUTH_COOKIE = exports.JWT_COOKIE = void 0;
var servers_1 = require("./servers");
exports.JWT_COOKIE = 'manifoldJWT';
exports.OAUTH_COOKIE = 'manifoldOAuth';
var getJWTKey = function (address, strict) {
    return strict ? exports.JWT_COOKIE + ":" + (address === null || address === void 0 ? void 0 : address.toLowerCase()) : exports.JWT_COOKIE;
};
var getOAuthKey = function (address, strict) {
    return strict ? exports.OAUTH_COOKIE + ":" + (address === null || address === void 0 ? void 0 : address.toLowerCase()) : exports.OAUTH_COOKIE;
};
var getJWT = function (address, strict) { return __awaiter(void 0, void 0, void 0, function () {
    var token, response, _a;
    var _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                token = localStorage.getItem(getJWTKey(address, strict));
                if (!token)
                    return [2 /*return*/, null];
                return [4 /*yield*/, fetch(servers_1.JWTServer + "/verify", {
                        headers: { Authorization: "Bearer " + token },
                    })];
            case 1:
                response = _c.sent();
                if (response.status !== 200) {
                    (0, exports.deleteJWT)(address, strict);
                    return [2 /*return*/, null];
                }
                _a = strict;
                if (!_a) return [3 /*break*/, 3];
                return [4 /*yield*/, response.json()];
            case 2:
                _a = ((_b = (_c.sent()).address) === null || _b === void 0 ? void 0 : _b.toLowerCase()) !== address.toLowerCase();
                _c.label = 3;
            case 3:
                // If strict, check address matches
                if (_a) {
                    (0, exports.deleteJWT)(address, strict);
                    return [2 /*return*/, null];
                }
                return [2 /*return*/, token];
        }
    });
}); };
exports.getJWT = getJWT;
var getOAuth = function (address, strict) { return __awaiter(void 0, void 0, void 0, function () {
    var token, response, _a;
    var _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                token = localStorage.getItem(getOAuthKey(address, strict));
                if (!token)
                    return [2 /*return*/, null];
                return [4 /*yield*/, fetch(servers_1.OAuthServer + "/verify", {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            Accept: 'application/json',
                        },
                        body: JSON.stringify({
                            token: token,
                        }),
                    })];
            case 1:
                response = _d.sent();
                if (response.status !== 200) {
                    (0, exports.deleteOAuth)(address, strict);
                    return [2 /*return*/, null];
                }
                _a = strict;
                if (!_a) return [3 /*break*/, 3];
                return [4 /*yield*/, response.json()];
            case 2:
                _a = ((_c = (_b = (_d.sent()).unwrappedJWT) === null || _b === void 0 ? void 0 : _b.address) === null || _c === void 0 ? void 0 : _c.toLowerCase()) !== address.toLowerCase();
                _d.label = 3;
            case 3:
                // If strict, check address matches
                if (_a) {
                    (0, exports.deleteOAuth)(address, strict);
                    return [2 /*return*/, null];
                }
                return [2 /*return*/, token];
        }
    });
}); };
exports.getOAuth = getOAuth;
var setJWT = function (address, strict, jwt) {
    localStorage.setItem(getJWTKey(address, strict), jwt);
};
exports.setJWT = setJWT;
var setOAuth = function (address, strict, token) {
    localStorage.setItem(getOAuthKey(address, strict), token);
};
exports.setOAuth = setOAuth;
var deleteJWT = function (address, strict) {
    localStorage.removeItem(getJWTKey(address, strict));
};
exports.deleteJWT = deleteJWT;
var deleteOAuth = function (address, strict) {
    localStorage.removeItem(getOAuthKey(address, strict));
};
exports.deleteOAuth = deleteOAuth;
